import { getEffectiveSelectionRange } from "../selection-tracker";

export async function getDocumentInfoCore(
  ctx: Word.RequestContext
): Promise<unknown> {
  const doc = ctx.document;
  const body = doc.body;
  doc.load("saved");
  const paragraphs = body.paragraphs;
  paragraphs.load("items");
  const sections = doc.sections;
  sections.load("items");
  const tables = body.tables;
  tables.load("items/rowCount,items/columnCount");
  const comments = doc.comments;
  comments.load("items/id");
  const selection = doc.getSelection();
  selection.load("text,isEmpty");
  await ctx.sync();

  return {
    paragraphCount: paragraphs.items.length,
    sectionCount: sections.items.length,
    tableCount: tables.items.length,
    commentCount: comments.items.length,
    saved: doc.saved,
    selection: {
      isEmpty: selection.isEmpty,
      preview:
        selection.isEmpty || !selection.text
          ? ""
          : selection.text.length > 200
            ? `${selection.text.slice(0, 200)}…`
            : selection.text,
    },
  };
}

export async function getSelectionInfoCore(
  ctx: Word.RequestContext
): Promise<unknown> {
  const effective = await getEffectiveSelectionRange(ctx);
  if (!effective) {
    return {
      isEmpty: true,
      text: "",
      characterCount: 0,
      paragraphIndex: null,
      source: "none",
    };
  }
  const parentParagraphs = effective.range.paragraphs;
  parentParagraphs.load("items/text");
  effective.range.load("text");
  await ctx.sync();

  const firstParaText = parentParagraphs.items[0]?.text ?? null;
  let paragraphIndex: number | null = null;
  if (firstParaText !== null) {
    const allParas = ctx.document.body.paragraphs;
    allParas.load("items/text");
    await ctx.sync();
    paragraphIndex = allParas.items.findIndex((p) => p.text === firstParaText);
    if (paragraphIndex === -1) {
      paragraphIndex = null;
    }
  }

  const text = effective.range.text ?? "";
  return {
    isEmpty: text.length === 0,
    text,
    characterCount: text.length,
    paragraphIndex,
    source: effective.source,
  };
}
